import { FormControlLabel, Grid, Typography } from "@mui/material";
import React from "react";
import { t } from "ttag";
import { Switch as CoolSwitch } from "../../../cool_widgets/Switch";
import { useStoreState } from "../../../models/RootStore";
import { enumOptions } from "./siteSetupForm";
import useSiteSetupInputs, { SectionTitle } from "./useSiteSetupInputs";

// Setup form, right column: internal labels (General) and billing, with the Enforce site package switch
const GeneralBillingSection = () => {
  const { formik, classes, row, half, renderText, renderSelect, renderDate, labelWithHint } = useSiteSetupInputs();
  const { values, setFieldValue } = formik;
  const { siteCategories, siteOnboardingStatus, sitePhases, sellingEntities } = useStoreState((s) => s.types);

  const handleEnforceChange = (event: any, checked: any) => {
    setFieldValue("isEnforcePackage", checked);
  };

  const enforceSwitch = (
    <FormControlLabel
      labelPlacement="start"
      className={classes.enforceSwitchLabel}
      control={
        <CoolSwitch
          color="default"
          name="isEnforcePackage"
          checked={values.isEnforcePackage}
          onChange={handleEnforceChange}
        />
      }
      label={
        <Typography variant="body2" component="span">
          {labelWithHint(
            t`Enforce site package`,
            t`Show a renewal notice to the site's users in the professional app, starting 3 months before the active period ends. Needs Active period start and end.`
          )}
        </Typography>
      }
    />
  );

  return (
    <Grid container columnSpacing={2}>
      <SectionTitle>{t`General`}</SectionTitle>
      {half(renderSelect("category", t`Facility type`, enumOptions(siteCategories)), "category")}
      {half(renderText("contractedIDUs", t`Licensed IDUs`, { type: "number", inputProps: { min: 0 } }), "contractedIDUs")}
      {half(renderSelect("onBoardingStatus", t`Onboarding status`, enumOptions(siteOnboardingStatus)), "onBoardingStatus")}
      {half(renderSelect("phase", t`Site journey phase`, enumOptions(sitePhases)), "phase")}

      <SectionTitle action={enforceSwitch} className={classes.sectionTitleSpaced}>{t`Billing`}</SectionTitle>
      {half(renderSelect("sellingEntity", t`Selling entity`, enumOptions(sellingEntities)), "sellingEntity")}
      {half(renderText("payingCustomerName", t`Paying customer name`), "payingCustomerName")}
      {half(renderText("invoiceNum", t`Invoice #`), "invoiceNum")}
      {half(renderText("PONum", t`PO Number`), "PONum")}
      {half(renderText("sfOrderNum", t`SF Order #`), "sfOrderNum")}
      {half(
        renderText("salesAccountEmail", t`Sales account email`, { type: "email", placeholder: t`name@coolautomation.com` }),
        "salesAccountEmail"
      )}
      {half(renderDate("activePeriodStart", t`Active period start`), "activePeriodStart")}
      {half(
        renderDate("activePeriodEnd", t`Active period end`, { minDate: values.activePeriodStart || undefined }),
        "activePeriodEnd"
      )}
    </Grid>
  );
};

export default GeneralBillingSection;
